/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { DocumentationView } from "./DocumentationView/DocumentationView";
import { DocumentationMain } from "./DocumentationView/components/DocumentationMain";
import { registerCommands } from "./Commands";
import { registerMenus } from "./Menus";

export function DocumentationModule(dc: IEditor): void {
	dc.get("logger").debug("Documentation module enabled.");

	const viewSvc = dc.get("viewService");

	viewSvc.registerView("documentation", DocumentationView, DocumentationMain);

	registerCommands(dc);
	registerMenus(dc);
}
